import { baseRequest } from '@/shared/request-configs/base-request';
import { IApiResponse, IMetaResponse } from '@/shared';

export class DataModifyProcessor<DataObjectType> {
  public url: string;
  public postItems: DataObjectType[];
  public putItems: (DataObjectType & { id?: null | number | string })[];
  public deleteItems: (DataObjectType & { id?: null | number | string })[];

  constructor(url: string) {
    this.url = url;
    this.postItems = [];
    this.putItems = [];
    this.deleteItems = [];
  }

  public async execute() {
    let postResult!: IApiResponse<DataObjectType[], IMetaResponse | null>;
    let putResult!: IApiResponse<DataObjectType[], IMetaResponse | null>;
    let deleteResult!: IApiResponse<DataObjectType[], IMetaResponse | null>;
    let modifiedResultSet: DataObjectType[] = [];

    if (this.deleteItems.length > 0) {
      const ids = this.deleteItems.map((item) => (item).id!).join(',');
      deleteResult = (await baseRequest.delete<IApiResponse<DataObjectType[], IMetaResponse | null>>(`${this.url}/${ids}`))
        || { data: [], meta: null };
    }

    if (this.putItems.length > 0) {
      putResult = await baseRequest.put(this.url, this.putItems);
    }

    if (this.postItems.length > 0) {
      postResult = await baseRequest.post(this.url, this.postItems);
    }

    modifiedResultSet = [
      ...(Array.isArray(putResult?.data) ? putResult?.data : [ putResult?.data ]),
      ...(Array.isArray(postResult?.data) ? postResult?.data : [ postResult?.data ]),
    ].reduce<DataObjectType[]>((acc, cur) => (cur ? [...acc, cur] : acc), []);

    return {
      postResult,
      putResult,
      deleteResult,
      modifiedResultSet,
    };
  }
}
